import { motion } from "framer-motion";
import { Card } from "../../../components/ui/Card";
import { Desktop, GraduationCap, Sparkle } from "@phosphor-icons/react";

const testimonials = [
  {
    quote:
      "Significantly improved our code quality. The AI catches subtle issues our team might miss during reviews.",
    author: "Andrew, Engineering Director",
    logo: (
      <Desktop
        size={32}
        weight="thin"
        className="group-hover:animate-subtle-float"
      />
    ),
  },
  {
    quote:
      "Great for knowledge sharing. Junior developers learn best practices directly from the AI's suggestions.",
    author: "Xavier, VP Engineering",
    logo: (
      <GraduationCap
        size={32}
        weight="thin"
        className="group-hover:animate-subtle-float"
      />
    ),
  },
  {
    quote:
      "Helps maintain consistent code standards across multiple teams. Integration was seamless.",
    author: "Kyle, Lead Architect",
    logo: (
      <Sparkle
        size={32}
        weight="thin"
        className="group-hover:animate-subtle-float"
      />
    ),
  },
];

const trustedBy = [
  "Tech Leaders",
  "Scale-ups",
  "Enterprise",
  "FinTech",
  "Software Teams",
  "Dev Agencies",
];

export function SocialProof() {
  return (
    <section className="relative py-32 bg-black/20">
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="aurora-gradient">Trusted by Industry Leaders</h2>
          <div className="mt-8 flex flex-wrap justify-center gap-8">
            {trustedBy.map((industry) => (
              <div key={industry} className="text-white/60 text-lg">
                {industry}
              </div>
            ))}
          </div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={testimonial.author}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
            >
              <Card variant="hover" className="p-8 h-full flex flex-col group">
                <span className="relative block mb-4">
                  <span className="relative z-10 transform text-white/70 group-hover:text-white transition-colors duration-300">
                    {testimonial.logo}
                  </span>
                </span>
                <p className="text-white/80 italic flex-grow">
                  &ldquo;{testimonial.quote}&rdquo;
                </p>
                <p className="mt-4 text-white/60 text-sm">
                  {testimonial.author}
                </p>
              </Card>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
